import { Currency } from '../../../../global/models';

/*
 * Trimmed under AB#112440, which reduced the public Giving surface to Campaign Commitment and Giving History and
 * removed Stripe.  Everything that existed only for the Giving Checkout flow -- DEFAULT_CAMPUS,
 * ONLINE_CAMPUS_NAME_PREFIX, APPLE_PLATFORMS, IOS_DEVICES, BEM_BLOCK_NAME_PAYMENT_CONFIG, CONTAINER_PADDING,
 * COUNTRY, COUNTRY_CODE, CUSTOM_AMOUNT_FLIP_DURATION, OCCURRENCE_TYPES, DURATION_DESCRIPTIONS,
 * RECURRENCE_TYPES_TO_STRING, PAYMENT_TYPES_TO_STRING, GIVING_LIST_VALUES, GIVING_ALLOWABLE_REGIONS,
 * DEFAULT_USER_AUTHENTICATION, DEFAULT_STATE, GivingCheckoutActionType, VALIDATOR_NUMERIC_WITH_DECIMALS,
 * WANT_TO_LEAVE_MESSAGE, WHAT_IS_TITHING_URL, CLIENT_IDS and CLIENT_ID_TO_FEATURE_ID -- has been removed.  What
 * remains is the campus mapping plus the few defaults and messages still used by the surviving shared components.
 */

/**
 * Contains a default value for 'Tenant URL' (host of tenant's/customer's main external website, e.g. https://saddleback.com)
 * read from the `.env` file.
 */
export const DEFAULT_TENANT_URL = process.env.DEFAULT_TENANT_URL; // eslint-disable-line prefer-destructuring

/**
 * Contains host URL for Healthy Church in the widget context.
 *
 * Can be used to specify absolute URLs for assets like images that are hosted by Healthy Church.
 */
export const HEALTHY_CHURCH_HOST_URL = process.env.HEALTHY_CHURCH_HOST_URL; // eslint-disable-line prefer-destructuring

export const MAX_WIDTH_GIVING_CONTAINER = 486;

export const DEFAULT_CURRENCY = Currency.USD;

export const DEFAULT_LOCALE: string = 'en-US'; // TODO: Duplicate constant declared in [`client/src/global/constants.js`](https://github.com/saddlebackdev/church-management/blob/dev/client/src/global/constants.js).  HOWEVER we do not want to depend on that guy right now, because it depends on i18n module and [`i18nMessageStore.js`](https://github.com/saddlebackdev/church-management/blob/dev/client/src/global/i18nMessagesStore.js).

export const DEFAULT_CLIENT_ID = 'cm';

/**
 * Regular expression to validate an email address
 *
 * Source: https://emailregex.com/
 */
export const VALIDATOR_EMAIL: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const PAYMENT_ERROR_MESSAGE = 'An error has occurred while submitting your gift. Please try again.';

export const DEFAULT_LOAD_ERROR_TITLE = 'An error has occurred.';

export const DEFAULT_LOAD_ERROR_SUBTITLE = 'The whole thing failed to load.  Sorry dude.';

/**
 * Campus ID 19 - Berlin, Germany
 */
export const CAMPUS_ID_BERLIN = 19;
/**
 * Campus ID 20 - Buenos Aires, Argentina
 */
export const CAMPUS_ID_BUENOS_AIRES = 20;
/**
 * Campus ID 22 - Hong Kong
 */
export const CAMPUS_ID_HONG_KONG = 22;
/**
 * Campus ID 25 - Santa Rosa, Philippines
 */
export const CAMPUS_ID_SANTA_ROSA = 25;
/**
 * Campus ID 63 - Vancover, Canada
 */
export const CAMPUS_ID_VANCOUVER = 63;

/**
 * Collection of the international campus IDs
 */
export const INTL_CAMPUS_IDS = [
    CAMPUS_ID_BERLIN,
    CAMPUS_ID_BUENOS_AIRES,
    CAMPUS_ID_HONG_KONG,
    CAMPUS_ID_SANTA_ROSA,
    CAMPUS_ID_VANCOUVER,
];

/**
 * Rock Campus ID 3 - Berlin, Germany
 *
 * ( HC Campus ID 19 - {@link CAMPUS_ID_BERLIN} )
 */
export const ROCK_CAMPUS_ID_BERLIN = 3;
/**
 * Rock Campus ID 5 - Buenos Aires, Argentina
 *
 * ( HC Campus ID 20 - {@link CAMPUS_ID_BUENOS_AIRES} )
 */
export const ROCK_CAMPUS_ID_BUENOS_AIRES = 5;
/**
 * Rock Campus ID 7 - Hong Kong
 *
 * ( HC Campus ID 22 - {@link CAMPUS_ID_HONG_KONG} )
 */
export const ROCK_CAMPUS_ID_HONG_KONG = 7;
/**
 * Rock Campus ID 17 - Santa Rosa, Philippines
 *
 * ( HC Campus ID 25 - {@link CAMPUS_ID_SANTA_ROSA} )
 */
export const ROCK_CAMPUS_ID_SANTA_ROSA = 17;
/**
 * Rock Campus ID 20 - Vancover, Canada
 *
 * ( HC Campus ID 63 - {@link CAMPUS_ID_VANCOUVER} )
 */
export const ROCK_CAMPUS_ID_VANCOUVER = 20;
/**
 * Mapping of Rock Campus IDs to equivalent Healthy Church Campus IDs
 */
export const ROCK_TO_HC_CAMPUS_ID_MAP: Record<number, number> = {
    [ROCK_CAMPUS_ID_BERLIN]: CAMPUS_ID_BERLIN,
    [ROCK_CAMPUS_ID_BUENOS_AIRES]: CAMPUS_ID_BUENOS_AIRES,
    [ROCK_CAMPUS_ID_HONG_KONG]: CAMPUS_ID_HONG_KONG,
    [ROCK_CAMPUS_ID_SANTA_ROSA]: CAMPUS_ID_SANTA_ROSA,
    [ROCK_CAMPUS_ID_VANCOUVER]: CAMPUS_ID_VANCOUVER,
};
